import React from "react";
import {connect} from "react-redux";
import {Translate} from "react-localize-redux";
import {Empty} from "antd";
import {NoFeaturedJobsIcon, NoJobsIcon} from "../../assets/Icons";
import {JobType} from "../../enums/enums";
import "./JobEmpty.scss";
import StoreState from "../../interfaces/store/storeState";

interface OwnProps {
    jobType: string
}

interface StateProps {
    visitWebsiteUrl: string
}

type Props = OwnProps & StateProps;

const JobEmpty: React.FC<Props> = ({jobType, visitWebsiteUrl}: Props): React.ReactElement => {
    const img: JSX.Element = jobType === JobType.FEATURED ? <NoFeaturedJobsIcon/> : <NoJobsIcon/>;
    const showAdditionalTxt: boolean = jobType === JobType.AVAILABLE;
    return (
        <Empty
            image={img}
            description={(
                <>
                    <div>
                        <Translate id={`emptyText.${jobType}_emptyTxt.text`}/>
                    </div>
                    {showAdditionalTxt
                    && (
                        <a
                            className="df-job-empty"
                            rel="noopener noreferrer"
                            href={visitWebsiteUrl}
                            target="_blank"
                        >
                            <Translate id="emptyText.websiteVisitText.text"/>
                        </a>
                    )}
                </>
            )}
        />
    );
};

function mapStateToProps(state: StoreState): StateProps {
    return {
        visitWebsiteUrl: state.serviceProperties.visitWebsiteUrl,
    };
}

export default connect(mapStateToProps)(JobEmpty);
